// removed by extract-text-webpack-plugin
module.exports = {"menuItem":"_1XD87sLOjY3SqR3UNPTMae"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/MainMenu/MainMenu.scss
// module id = 187
// module chunks = 0